import { useSirenEntity, useMeasurement, useBinLevelMeasurementOverrides } from '~/utility/BinSentry-ui-utility';

export const useBinCapacity = ({ binHref }) => {
  const { entity } = useSirenEntity({ href: binHref });
  const measurementOverrides = useBinLevelMeasurementOverrides({ bin: entity });
  const measurement = useMeasurement({ name: 'binLevel', ...measurementOverrides });

  if (!entity) {
    return null;
  }

  const { volumes, bulkDensity } = entity.properties;

  return {
    binCapacity: `${measurement.convert({ volume: volumes.fullTotal, bulkDensity })} ${measurement.unit}`,
    unit: measurement.unit,
    bulkDensity,
  };
};
